import React from "react";
import "./yatri.scss";
import { Box, Container, Grid, Typography } from "@mui/material";

function YatriPack() {
  
const travelKitItems = [
  "TISSUE PAPER",
  "SHOE COVER",
  "DISPOSABLE SOCKS",
  "WET TISSUE",
  "EYE MASK",
  "SANITIZER",
  "HANDWASH",
  "TOFFEE",
  "RAIN PONCHO",
  "ORS SACHET",
  "BOROLINE",
  "PLASTIC TUMBLER",
  "BAND-AID",
  "REUNITE QR STICKER",
  "ROUTE GUIDE CARD",
  "DUST MASK",
  "ZIPPER POUCH",
];


const pricingData = [
  {
    price: "₹149",
    title: "Essential Pack",
    desc: "All basic hygiene essentials for a hassle-free yatra.",
    btn: "Order Essential Pack",
  },
  {
    price: "₹249",
    title: "Yatri Comfort Pack",
    desc: "Complete comfort & hygiene for your journey.",
    btn: "Order Yatri Pack",
    featured: true,
  },
  {
    price: "₹399",
    title: "Premium Pilgrim Pack",
    desc: "All essentials + Reunite Band for extra safety & peace of mind.",
    btn: "Order Premium Pack",
  },
];

  const steps = [
  {
    icon: "/assets/yatri-pack/icons/safe.svg",
    title: "Safe",
    desc: "Travel essentials to keep you protected and worry-free.",
  },
  {
    icon: "/assets/yatri-pack/icons/carry.svg",
    title: "Easy to Carry",
    desc: "Compact and lightweight design so you can carry with ease.",
  },
  {
    icon: "/assets/yatri-pack/icons/quality.svg",
    title: "Premium Quality",
    desc: "Trusted brands and high-quality items for the best experience.",
  },
  {
    icon: "/assets/yatri-pack/icons/quality.svg",
    title: "Saves Time",
    desc: "All your travel essentials in one pack. No last-minute shopping.",
  },
  {
    icon: "/assets/yatri-pack/icons/pilgrim.svg",
    title: "Made for Pilgrims",
    desc: "Curated keeping pilgrims' real needs in mind for a better yatra.",
  },
  {
    icon: "/assets/yatri-pack/icons/care.svg",
    title: "Thoughtful Care",
    desc: "Supporting you at every step, so your journey remains blessed.",
  },
];


const features = [
  {
    icon: "fa fa-qrcode",
    title: "QR for Quick ID",
  },
  {
    icon: "fa fa-phone",
    title: "Emergency Contact",
  },
  {
    icon: "fa fa-users",
    title: "Kids, Elderly & Family",
  },
  {
    icon: "fa fa-shield",
    title: "Waterproof & Durable",
  },
];


const packItems = [
  "TISSUE PAPER",
  "SHOE COVER",
  "DISPOSABLE SOCKS",
  "WET TISSUE",
  "EYE MASK",
  "SANITIZER",
  "HANDWASH",
  "TOFFEE",
  "RAIN PONCHO",
  "ORS SACHET",
  "BOROLINE",
  "PLASTIC TUMBLER",
  "BAND-AID",
  "REUNITE TAG",
  "ROUTE GUIDE CARD",
  "DUST MASK",
  "ZIPPER POUCH",
];

  return (
    <>
      <Box className="hero-banner ">
        <Container maxWidth="lg">
          <Grid container justifyContent="center">
            <Grid size={12}>
              <div className="hero-content">
                <span className="badge-tag">INTRODUCING</span>

                <h1>
                  YATRI PACK
                </h1>
                <h3>Everything you need. nothing you forgot.</h3>
                <p>
                  Thoughtfully packed essentials for a safe, <br /> comfortable and blessed journey to Mata Rani.
                </p>
                <div className="hero-buttons">
               <a href="/contact-us" className="reserve-btn text-decoration-none">
               Booking guide
               </a>
               <a href="#thirdBanner" className="learn-btn text-decoration-none">
               How it works
               </a>
            </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

   {/* <section className="travelKitSection">
      <Container maxWidth="lg">
        <Grid container>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Box className="templeInnerHeading">
              <h2 className="mt-1">What's Inside Your Yatri Pack?</h2>
              <p>
                17 carefully chosen essentials packed in a durable pouch for easy carrying.
              </p>
            </Box>

            <div className="travelKitWrapper">
              {travelKitItems.map((item, index) => (
                <div className="kitItem" key={index}>
                  <span className="icon">
                    <i className="fa fa-check"></i>
                  </span>

                  <span className="text">{item}</span>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </Container>
</section> */}

 <section className="howItWorks yatriPack">
  <img
    className="yatriCornerImg"
    src="/assets/yatri-pack/side-img.webp"
    alt=""
  />
      <Container maxWidth="lg">
        <Grid container spacing={{ xl: 5, lg: 4, md: 4, sm: 4, xs: 3 }}>
          
          {/* Left Image */}
          <Grid
            size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}
          >
            <Box className="yatriImageBox">
              <img
                src="/assets/yatri-pack/yatri-pack.webp"
                alt="Yatri Pack - 17 essential items"
              />

             
            </Box>
          </Grid>

          {/* Right Content */}
          <Grid
            size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}
          >
            <Box className="yatriContent">
              
              <Box className="templeInnerHeading">
                <h2 className="mt-1">
                  What's Inside Your <span>Yatri Pack?</span>
                </h2>

                <p>
                  17 carefully chosen essentials, packed in a durable
                  pouch that travels as lightly as you do.
                </p>
              </Box>

              <Box className="packItems">
                {packItems.map((item, index) => (
                  <Box className="packItem" key={index}>
                    <span className="checkIcon">✓</span>

                    <Typography component="span">
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>

            </Box>
          </Grid>

        </Grid>
      </Container>
    </section>

   <section className="howItWorks">
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading">
                
                <h2 className="mt-1">Why Pilgrims Love Yatri Pack</h2>
                <p>Carefully designed to make your yatra safe, comfortable, and truly blessed.</p>
              </Box>

              
            </Grid>

             {steps.map((item, index) => (
        <Grid
          key={index}
          size={{ xl: 4, lg: 4, md: 6, sm: 6, xs: 12 }}
        >
          <Box className="workCard">

            <div className="iconBox">
               <img src={item.icon} alt={item.title} height="25" width="25" />
              
            </div>

            <Typography variant="h6">
              {item.title}
            </Typography>

            <Typography className="description">
              {item.desc}
            </Typography>

          </Box>
        </Grid>
      ))}
          </Grid>
        </Container>
      </section>

       
<Box className="qrBandBanner">
  <Container maxWidth="lg">
    <Grid container>
      <Grid size={12}>
        <div className="bannerContent">

          <span className="badgeTag">
            EXTRA SAFETY WITH
          </span>

          <h2>Reunite QR Band</h2>

          <p>
            A small band with a big purpose your safety,
            
            always connected.
          </p>

          <div className="featureList">

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/qr.svg" alt="" height="20px" width="20px" className="img-fluid" />
              </span>
              <span>QR for Quick ID</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/phone.svg" alt="" height="30px" width="30px" className="img-fluid" />
              </span>
              <span>Emergency Contact</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/kids.svg" alt="" height="25px" width="25px" className="img-fluid" />
              </span>
              <span>Kids, Elderly & Family</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/shield.svg" alt="" height="25px" width="25px" className="img-fluid" />
              </span>
              <span>Waterproof & Durable</span>
            </div>

          </div>

          <button className="knowBtn">
            KNOW MORE
          </button>

        </div>
      </Grid>
    </Grid>
  </Container>
</Box>


<Box className="qrBandBanner walikingStick my-5">
  <Container maxWidth="lg">
    <Grid container>
      <Grid size={12}>
        <div className="bannerContent">
          <div className="text-md-end">
          <span className="badgeTag">
            YATRASATHI
          </span>

          <h2>Smart Walking Stick</h2>

          <p>
           Your perfect yatra companion support, safety, stability.
          </p>
          </div>

          <div className="featureList">

            <div className="featureItem">
              
              <span>Ergonomic Grip</span>
              <span className="icon ms-3">
                <img src="/assets/yatri-pack/icons/grip.svg" alt="" height="25px" width="25px" className="img-fluid" />
              </span>
            </div>

            <div className="featureItem">
              
              <span>Walking Support</span>
              <span className="icon ms-3">
                <img src="/assets/yatri-pack/icons/support.svg" alt="" height="25px" width="25px" className="img-fluid" />
              </span>
            </div>

            <div className="featureItem">
             
              <span>Built-in LED Light</span>
               <span className="icon ms-3">
                <img src="/assets/yatri-pack/icons/led.svg" alt="" height="25px" width="25px" className="img-fluid" />
              </span>
            </div>

            <div className="featureItem">
              
              <span>Sturdy & Anti-Slip</span>
              <span className="icon ms-3">
                <img src="/assets/yatri-pack/icons/anti-slip.svg" alt="" height="22px" width="22px" className="img-fluid" />
              </span>
            </div>

          </div>

          <button className="knowBtn">
            KNOW MORE
          </button>

        </div>
      </Grid>
    </Grid>
  </Container>
</Box>
     


<Box className="qrBandBanner thirdBanner" id="thirdBanner">
  <Container maxWidth="lg">
    <Grid container>
      <Grid size={12}>
        <div className="bannerContent">

      

          <h2>Order Easily on the MandirWiki App</h2>

          <p>
            BE PREPARED. TRAVEL BETTER. <br />
HAVE A BLESSED YATRA.
          </p>

          <div className="featureList">

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/payment.svg" alt="" height="22px" width="22px" className="img-fluid" />
              </span>
              <span>Secure Payment</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/booking.svg" alt="" height="22px" width="22px" className="img-fluid" />
              </span>
              <span>Quick & Easy Booking</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/delivery.svg" alt="" height="22px" width="22px" className="img-fluid" />
              </span>
              <span>Fast Delivery</span>
            </div>

            <div className="featureItem">
              <span className="icon">
                <img src="/assets/yatri-pack/icons/travel.svg" alt="" height="22px" width="22px" className="img-fluid" />
              </span>
              <span>Travel Worry-Free</span>
            </div>

          </div>

          <button className="knowBtn">
            ORDER NOW
          </button>

        </div>
      </Grid>
    </Grid>
  </Container>
</Box>
      

       <section className="serviceCardsSection">
  <Container maxWidth="lg">
    <Grid container spacing={4}>
      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
        <Box className="templeInnerHeading">
          <h2 className="mt-1">Choose Your Perfect Pack</h2>
          <p>Travel Light. Travel Right.</p>
        </Box>
      </Grid>

      {pricingData.map((item, index) => (
        <Grid
          key={index}
          size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}
        >
          <Box className={`pricingCard ${item.featured ? "featured" : ""}`}>
            {item.featured && (
              <span className="popularBadge">Most Popular</span>
            )}

            <h3 className="price">{item.price}</h3>

            <h4>{item.title}</h4>

            <p>{item.desc}</p>

            <button>{item.btn}</button>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Container>
</section>
    </>
  );
}

export default YatriPack;